// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCz8TlB0vFscLWrQlc0uttsXBLR5RMVLnc",
  authDomain: "liiviiart-2f3b4.firebaseapp.com",
  projectId: "liiviiart-2f3b4",
  storageBucket: "liiviiart-2f3b4.firebasestorage.app",
  messagingSenderId: "575525226033",
  appId: "1:575525226033:web:743a1c4a5531b77727f710",
  measurementId: "G-EW4NYP8SF2"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);